var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgToasterError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3077 19.9231C21.69 20.3054 21.69 20.9254 21.3077 21.3077C20.9253 21.6901 20.3054 21.69 19.9231 21.3077L16.7071 18.0917C16.3166 17.7012 15.6834 17.7012 15.2929 18.0917L12.0769 21.3077C11.6945 21.69 11.0746 21.69 10.6923 21.3077C10.31 20.9254 10.3099 20.3055 10.6923 19.9231L13.9083 16.7071C14.2988 16.3166 14.2988 15.6834 13.9083 15.2929L10.6923 12.0769C10.31 11.6946 10.3099 11.0747 10.6923 10.6923C11.0746 10.31 11.6946 10.31 12.0769 10.6923L15.2929 13.9083C15.6834 14.2988 16.3166 14.2988 16.7071 13.9083L19.923 10.6923C20.3054 10.31 20.9253 10.31 21.3077 10.6923C21.69 11.0747 21.69 11.6946 21.3077 12.077L18.0917 15.2929C17.7012 15.6834 17.7012 16.3166 18.0917 16.7071L21.3077 19.9231Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToasterError);
export default __webpack_public_path__ + "static/media/toaster-error.f325c019231786f94300e9342ca14781.svg";
export { ForwardRef as ReactComponent };